import {Component, tag} from 'doz'

@tag('contacts')
export default class extends Component {

    template(h) {
        return h`
            <style>
                .container {
                    color: ${this.PLAYER_CONFIG.contactsTextColor || this.THEME.onPrimaryColor};
                    background: ${this.PLAYER_CONFIG.contactsBackgroundColor || this.THEME.primaryColor};
                    border-color: ${this.PLAYER_CONFIG.contactsSeparatorColor || ''};
                    /*text-align: center;*/
                }
                
                h3 {
                    color: ${this.PLAYER_CONFIG.contactsTitleColor || this.THEME.onPrimaryColor};
                }
                
                .icon {
                    color: ${this.PLAYER_CONFIG.contactsIconColor || this.THEME.onPrimaryColor};
                }
                
                a, a:link, a:visited, a:active {
                    color: ${this.PLAYER_CONFIG.contactsTextColor || this.THEME.onPrimaryColor};
                    text-decoration: underline;
                }
                
                .list {
                    list-style: none;
                    margin: 0;
                    padding: 0;
                    text-align: ${this.PLAYER_CONFIG.contactsAlignment};
                }
                
                .list li{
                    padding: 0;
                }
                
                .list li i{
                    width: 20px;
                    font-size: 20px;
                    font-weight: bold;
                    margin-right: 8px;
                    margin-bottom: 8px;
                }
                
                .custom-body {
                    margin-bottom: 24px;
                }
                /*
                
                https://share.xdevel.com/api/?platform=earone_8&key=dd2c739b9b3fe8f849b5cec87727f41d&get=playlist
                 */
            </style>
            <div class="container">
                <h3>${this.PLAYER_CONFIG.contactsTitleText || 'Contatti'}</h3>
                <ul class="list animated fadeIn">
                    <li d-show="${!!this.PLAYER_CONFIG.telephone}"> 
                        <i class="icon fal fa-phone-square-alt"></i> <a href="tel:${this.PLAYER_CONFIG.telephone}">${this.PLAYER_CONFIG.telephone}</a>
                    </li>
                    <li d-show="${!!this.PLAYER_CONFIG.whatsApp}"> 
                        <i class="icon fab fa-whatsapp"></i> <a href="https://api.whatsapp.com/send?phone=${this.PLAYER_CONFIG.whatsApp}">${this.PLAYER_CONFIG.whatsApp}</a>
                    </li>
                    <li d-show="${!!this.PLAYER_CONFIG.telegram}"> 
                        <i class="icon fab fa-telegram-plane"></i> <a target="_blank" href="https://telegram.me/${this.PLAYER_CONFIG.telegram}">${this.PLAYER_CONFIG.telegram}</a>
                    </li>
                    <li d-show="${!!this.PLAYER_CONFIG.sms}"> 
                        <i class="icon fal fa-sms"></i> <a href="sms:${this.PLAYER_CONFIG.sms}">${this.PLAYER_CONFIG.sms}</a>
                    </li>
                    <li d-show="${!!this.PLAYER_CONFIG.email}"> 
                        <i class="icon fal fa-envelope"></i> <a href="mailto:${this.PLAYER_CONFIG.email}">${this.PLAYER_CONFIG.email}</a>
                    </li>
                    <li d-show="${!!this.PLAYER_CONFIG.website}"> 
                        <i class="icon fal fa-browser"></i> <a target="_blank" href="${this.PLAYER_CONFIG.website}">${this.PLAYER_CONFIG.website ? this.PLAYER_CONFIG.website.replace(/https?:\/\//, '') : ''}</a>
                    </li>
                </ul>
                <div d-show="${!!this.PLAYER_CONFIG.contacts}" class="custom-body animated fadeIn">
                    ${this.PLAYER_CONFIG.contacts}
                </div>
            </div>
        `
    }


}
